import { useState, useEffect } from 'react'

const BANNER_KEY = 'imarket_banner_dismissed'

export function useBannerState(onBannerClose?: () => void) {
  const [visible, setVisible] = useState(
    () => localStorage.getItem(BANNER_KEY) !== 'true'
  )
  const [countdown, setCountdown] = useState<number | null>(null)
  const [isPlayBtnVisible, setIsPlayBtnVisible] = useState(
    () => localStorage.getItem(BANNER_KEY) === 'true'
  )

  const handleClosePermanent = () => {
    setVisible(false)
    setIsPlayBtnVisible(true)
    localStorage.setItem(BANNER_KEY, 'true')
    onBannerClose?.()
  }

  const handleCloseAuto = () => {
    setVisible(false)
    onBannerClose?.()
  }

  const handleReplay = () => {
    localStorage.setItem(BANNER_KEY, 'false')
    setIsPlayBtnVisible(false)
    setVisible(true)
    setCountdown(null)
  }

  useEffect(() => {
    if (!visible) return
    const timer = setTimeout(handleCloseAuto, 10000)
    return () => clearTimeout(timer)
  }, [visible])

  useEffect(() => {
    if (!visible) return
    const t = setTimeout(() => setCountdown(5), 5000)
    return () => clearTimeout(t)
  }, [visible])

  useEffect(() => {
    if (countdown === null) return
    if (countdown === 0) {
      const t = setTimeout(handleCloseAuto, 0)
      return () => clearTimeout(t)
    }
    const t = setTimeout(() => setCountdown(c => c !== null ? c - 1 : null), 1000)
    return () => clearTimeout(t)
  }, [countdown])

  return { visible, countdown, isPlayBtnVisible, handleClosePermanent, handleCloseAuto, handleReplay }
}